import React from "react";
import { WalletCardProps } from "./types";
import { Card, CircleIconContainer, CurrencyPrice } from "@letsbit/milkylb";
import { useWallets } from "hooks/user/useWallets";
import { useFormatter } from "hooks/utils/useFormatter";
import { useCoinValues } from "hooks/user/useCoinValues";
import { useThemeToBody } from "hooks/utils/useThemeToBody";

export const WalletCard: React.FC<WalletCardProps> = ({
  element: currency,
  classname
}) => {
  const { data: wallets } = useWallets();
  const { preferredCurrency } = useCoinValues();
  const { getThemeUrlIcon } = useThemeToBody();

  const showPreferredCurrency = preferredCurrency?.ticker_id.toUpperCase();
  const { formatValue } = useFormatter();

  return wallets ? (
    <Card
      className={`shrink-0 ${classname}`}
      key={currency.id}
      title={wallets[currency.id].ticker_id.toUpperCase() || ""}
      subtitle={wallets[currency.id].name || ""}
      icon={
        <CircleIconContainer
          icon={getThemeUrlIcon(wallets[currency.id].icon_url)}
        />
      }
    >
      <CurrencyPrice
        price={formatValue(
          wallets[currency.id].total_balance === ""
            ? "0"
            : wallets[currency.id].total_balance,
          wallets[currency.id].precision
        )}
        priceCurrency={""}
        variation={`≈ ${
          wallets[currency.id].total_balance_preferred_currency
        } ${showPreferredCurrency}`}
      />
    </Card>
  ) : null;
};
